import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import Typography from "@material-ui/core/Typography/Typography";
import {Translate} from "../../../../config/Translate";
import {imgSize} from "../../../../config/values";
import FolderIcon from '@material-ui/icons/Folder';
import Button from "@material-ui/core/Button/Button";
import axios from "axios";
import {defaultVariabls} from "../../../../config";
import {connect, setStore} from "trim-redux";
import AddDirectoryButton from "./AddDirectoryButton";
import Breadcrumbs from "@material-ui/core/Breadcrumbs/Breadcrumbs";
import DirectorySettingButton from "./DirectorySettingButton";
import FolderOpenRoundedIcon from '@material-ui/icons/FolderOpenRounded';
import AppCardLoaderFields from "../../../components/Skeletons/AppCardLoaderFields";
import List from "@material-ui/core/List/List";
import ListItem from "@material-ui/core/ListItem/ListItem";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar/ListItemAvatar";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction/ListItemSecondaryAction";
import {FieldSkeleton} from "../../../components/Skeletons/FieldSkeleton";
import {ListSkeleton} from "../../../components/Skeletons/ListSkeleton";
import withWidth from "@material-ui/core/withWidth/withWidth";
import {withSnackbar} from "notistack";
class SingleFileChooser extends React.Component {
    classes = this.props.classes;
    state = {
        loading:true,
        directories:[],
        current_directory:null,
        history:[
            {
                name: Translate.all,
                id:null
            }
        ]
    }
    componentDidMount(){
        this.loadData();
    }
    async loadData(){
        this.setState({
            loading:true
        })
        let loginToken = localStorage.getItem('ACT');
        let {current_directory} = this.state;
        this.props.handleCurrentDirectory(current_directory);
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/files-directories/getAll${!!current_directory ? "/"+current_directory : '' }`, config)
                .then(response => {
                    this.setState({
                        directories:response.data,
                        loading:false
                    })
                }).catch(error => {
                    console.log(error.response)
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
                loading:false
            });
            this.setState({
                loading:false
            })
        }
    }
    classes = this.props.classes;
    async handleClick(directory){
        let {history} = this.state;
        if(directory === "all"){
            await this.setState({
                current_directory:null,
                history
            })
        }else if(directory === "uncat"){
            await this.setState({
                current_directory:"uncat",
                history
            })
        }else{
            await history.push({
                name: directory.name,
                id:directory.id
            })
            await this.setState({
                current_directory:directory.id,
                history
            })
        }

        await this.loadData()
    }
    async handleClickBread(item){
        let {history} = this.state;
        let new_history = [];
        let dont_resume = false;
        await history.map((bread) => {
            if(!dont_resume){
                new_history.push(bread);
            }
            if(bread.id === item.id){
                dont_resume = true;
            }
        })
        await this.setState({
            history:new_history,
            current_directory:item.id
        })
        await this.loadData()
    }
    changeHistory(data){
        let {history} = this.state;
        history[history.length - 1].name = data.name;
        this.setState({
            history
        })
        this.loadData();
    }
    render(){
        let {loading,directories,current_directory,history} = this.state;
        let {move} = this.props;
        let current = history[history.length - 1];
        return(
            <div
                style={{
                    height:"100%",
                    overflow:"auto",
                    background:this.props.primary_color,
                    padding:10
                }}
            >
                {
                    !!loading ?
                        <ListSkeleton style={{borderRadius:4}}/>
                        :
                    <>
                        {
                            history.length > 1 &&
                            <div className="bread-section">
                                <Breadcrumbs aria-label="breadcrumb" separator={<span style={{color:"#fff"}}>/</span>}>
                                    {
                                        history.map((item,index) => (
                                            <Button
                                                key={index}
                                                style={{color:current.id === item.id ? this.props.secondary_color : "#fff"}}
                                                size="small"
                                                onClick={() => this.handleClickBread(item)}
                                            >
                                                {item.name}
                                            </Button>
                                        ))
                                    }
                                </Breadcrumbs>
                            </div>
                        }

                        <div className="directories">
                            <AddDirectoryButton
                                current_directory={current_directory}
                                reload={() => this.loadData()}
                                empty={directories.length === 0}
                            />
                            <List className={this.classes.gridDirectories}>
                                {
                                    history.length === 1 &&
                                    <>
                                        <ListItem
                                            className={null === current_directory ? "active" : 'deactive'}
                                            button
                                            onClick={() => this.handleClick("all")}
                                        >
                                            <ListItemText primary={Translate.all} className={"file-directory-text"}/>
                                        </ListItem>
                                        <ListItem
                                            className={"uncat" === current_directory ? "active" : 'deactive'}

                                            button
                                            onClick={() => this.handleClick('uncat')}
                                        >
                                            <ListItemText primary={Translate.unCategorized} className={"file-directory-text"}/>
                                        </ListItem>
                                    </>
                                }

                                {
                                    directories.map((directory,index) =>(
                                        <ListItem
                                            button
                                            key={index}
                                            className={directory.id === current_directory ? "active" : 'deactive'}
                                            onClick={() => this.handleClick(directory)}
                                        >
                                            <ListItemText primary={directory.name} className={"file-directory-text"}/>
                                            <ListItemSecondaryAction>
                                                <DirectorySettingButton
                                                    current={directory}
                                                    reload={(data) => this.changeHistory(data)}
                                                />
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    ))
                                }
                            </List>


                        </div>
                    </>
                }

            </div>
        )

    }
}
const mstp = state => ({
    primary_color: state.primary_color,
    secondary_color: state.secondary_color
});
export default withWidth()(withSnackbar(withStyles(Styles)(connect(mstp)(SingleFileChooser))));
